import { render } from "./TableOperations.vue?vue&type=template&id=40dad7e6&scoped=true"
import script from "./TableOperations.vue?vue&type=script&lang=js"
export * from "./TableOperations.vue?vue&type=script&lang=js"

import "./TableOperations.vue?vue&type=style&index=0&id=40dad7e6&lang=sass&scoped=true"
import "./TableOperations.vue?vue&type=style&index=1&id=40dad7e6&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dad7e6"]])

export default __exports__